import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Container, Row, Col, Form } from 'react-bootstrap';
import { pageReady, isNumeric } from '../services/UtilityService'
import APIService from '../services/APIService';

export default class TeamMetricsSortPage extends Component {
    constructor(props) {
        super(props);
        this.labels = []
        this.matches = []
        this.state = {
            rawdata: [],
            selectedMetric: "",
            ready: false,
            title: true,
            metricNames: [],
            teams: [],
            sortedMetrics: [],
        }
        // this.handleUpdateTeamNumber = this.handleUpdateTeamNumber.bind(this);
        if (props.title !== undefined) { this.state.title = props.title }
    }

    componentDidMount() {
        pageReady();
        let instanceID = localStorage.getItem("instanceId");
        let event = localStorage.getItem("event");

        if (instanceID === null || event === null) {
            window.location = '/'
        }
        this.getConfigData();
    }

    populateTable() {
        const { sortedMetrics } = this.state;
        // if(Object.keys(metricData).length !== 0) {
        let returnTag = [];
        //     var labels = this.labels
        //     for (let idx = 0; idx < labels.length; idx++) {
        //         if (!(labels[idx] in metricData)) {
        //             continue;
        //         }
        //         var fields = Object.keys(metricData[labels[idx]]);
        //         var fieldArray = [];
        //         fields.forEach(field => {
        //             fieldArray.push([field, metricData[labels[idx]][field]])
        //         })
        returnTag.push(
            <tr>
                <th>Team Number</th>
                <th>Value</th>
            </tr>
        )
        sortedMetrics.map((metric) => (
            returnTag.push(
                <tr>
                    <td>metric[0]</td>
                    <td>metric[1]</td>
                </tr>
            )
        ));
        return returnTag;
                // returnTag.push(
                //     <Table responsive hover striped key={idx}>
                //         <tbody>
                            // {fieldArray.map((values) => (
                            //     <tr>
                            //         <th>{String(values[0])}</th>
                            //         <td>{values[1] == null ? 'N/A' : String(values[1].toFixed(2))}</td>
                            //     </tr>
                            // ))}
                //          </tbody>
                //      </Table>
                // )
        //                 </Accordion.Body>
        //             </Accordion.Item>
        //         : null
        //     }
        //     return (returnTag);
        // } else {
        // return <h3>Data loading {'.'.repeat(Math.floor((Math.random() * 5) + 1))}</h3>;
        // }
    }

    getConfigData() {
        let instanceId = localStorage.getItem("instanceId")
        let event = localStorage.getItem("event")
        let metricFieldsAddress = `${instanceId}/${event}/metrics`
        let teamNumberAddress = `${instanceId}/${event}/teams`
        let metricNames = []
        let teamNumbers = []

        // Get name of all metrics from config data
        APIService.get('CONFIG', metricFieldsAddress).then(fieldsResponse => {
            let metricFields = fieldsResponse.data.metrics;
            metricFields.forEach(field => {
                metricNames.push(field.name)
            });
            this.setState({
                metricNames: metricNames
            })
        }).catch(function (error) {
            APIService.error(error);
        });

        APIService.get('CONFIG', teamNumberAddress).then(fieldsResponse => {
            let teamNumber = fieldsResponse.data.team_list;
            teamNumber.forEach(team => {
                teamNumbers.push(parseInt(team))
            });
            console.log(teamNumbers)
            this.setState({
                teams: teamNumbers
            })
        }).catch(function (error) {
            APIService.error(error);
        });

    }

    // clearData() {
    //     var metricData = this.metricData;
    //     this.metricData = metricData;
    // }

    getData(selectedMetric) {
        this.setState({
            loading: true
        })
        let instanceID = localStorage.getItem("instanceId");
        let event = localStorage.getItem("event");
        let { teams } = this.state;
        let metrics = {};
        console.log("selected: ", selectedMetric)

        // Map the teams array to an array of promises
        const promises = teams.map((team) => {
            console.log(team);
            let metricAddress = `${instanceID}/${team}/${event}/metric`;
            return APIService.get('METRIC', metricAddress)
                .then((metricResponse) => {
                    return { team, metric: parseFloat(metricResponse.data.data[0].metrics[selectedMetric]) };
                })
                .catch((error) => {
                    APIService.error(error);
                    return null;
                });
        });

        // Wait for all promises to resolve
        Promise.all(promises)
            .then((results) => {
                results.forEach((result) => {
                    if (result) {
                        if (! isNumeric(result.metric)) {
                            metrics[result.team] = 0;
                        } else {
                            metrics[result.team] = result.metric;
                        }
                    }
                });

                console.log("Metrics:", metrics);

                const sortedMetrics = Object.entries(metrics).sort((a,b) => b[1]-a[1])

                this.setState({
                    sortedMetrics: sortedMetrics,
                    loading: false
                })
                console.log("Sorted Metrics:", sortedMetrics);

                // Do something with the sorted metrics object
            })
            .catch((error) => {
                console.error('Error in Promise.all:', error);
            });
    }

    render() {

        // const handleSubmit = (event) => {
        //     event.preventDefault();
        //     this.getData()
        // };

        const getMetrics = () => {
            let { metricNames } = this.state;
            let options = []
            options.push(<option>Select a metric</option>)
            for (let idx = 0; idx < metricNames.length; idx++) {
                options.push(<option>{metricNames[idx]}</option>)
            }
            return options
        };

        const handleUpdateMetric = (event) => {
            this.setState({ selectedMetric: event.target.value });
            console.log(event.target.value)
            this.getData(event.target.value)
        }

        return (
            <div className='container'>
                {this.state.title ? <h1> Metrics </h1> : null}
                <Form>
                    <Form.Group className="mb-3">
                        <Container>
                            <Row xs="auto">
                                <Col>
                                    <Form.Select aria-label="Default select example" onChange={handleUpdateMetric}>
                                        {getMetrics()}
                                    </Form.Select>

                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Container>
                    </Form.Group>
                </Form>
                <Table responsive hover striped>
                    {this.state.selectedMetric ?
                    <thead>
                        <tr>
                            <th>Team Number</th>
                            <th>{this.state.selectedMetric}</th>
                        </tr>
                    </thead>
                    : null}
                    <tbody>
                        {this.state.sortedMetrics.map((metric) => (
                            <tr>
                                <th>{String(metric[0])}</th>
                                <td>{metric[1] == null ? 'N/A' : String(metric[1].toFixed(2))}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                    {/* {this.state.ready ? this.populateTable() : null} */}
            </div>)
    }
}